// src/components/Preloader.js
import React, { useEffect, useState } from 'react';
import './Preloader.css'; // Make sure this file exists
import logo from '../assets/images/festiva_logo.svg'; // Replace with the actual path to your logo

const Preloader = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress >= 100) {
          clearInterval(interval);
          return 100;
        }
        return oldProgress + 1;
      });
    }, 20); // Progress increment speed

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="preloader1">
      <img src={logo} alt="App Logo" className="preloader-logo" /> {/* Logo */}
      <div className="progress-container1">
        <div className="progress-bar1" style={{ width: `${progress}%` }} />
      </div>
      <p>Loading... {progress}%</p>
    </div>
  );
};

export default Preloader;